import React, { useState } from 'react';
import { api } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { Watch, CheckCircle2 } from 'lucide-react';

export const WatchPairPage = () => {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    const clean = code.replace(/\D/g, '');
    if (clean.length !== 6) {
      toast.error('Inserisci le 6 cifre mostrate dal Watch');
      return;
    }
    setBusy(true);
    try {
      await api.post('/watch/pair/claim', { user_code: clean });
      setDone(true);
      toast.success('Apple Watch collegato!');
    } catch (err) {
      const msg = err.response?.data?.detail || 'Errore: il codice potrebbe essere scaduto o già usato';
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Watch className="h-5 w-5 text-primary" />
            Collega Apple Watch
          </CardTitle>
          <CardDescription>
            Apri l'app LeagueHub sul tuo Apple Watch, scegli "Collega" e inserisci qui sotto il codice di 6 cifre mostrato.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="text-center py-6 space-y-3">
              <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" />
              <p className="font-semibold">Watch collegato.</p>
              <p className="text-sm text-muted-foreground">
                Puoi tornare al Watch. Il login è valido un anno.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                placeholder="123456"
                className="text-center text-3xl font-mono tracking-widest h-16"
                autoFocus
              />
              <Button type="submit" className="w-full" disabled={busy}>
                {busy ? 'Collegamento…' : 'Collega Watch'}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default WatchPairPage;
